<template>
    <div class="wrap-content">

        <div class="content-login">
            <div class="brand">
                <div>
                    <img src="../assets/Kinesis-LDNS-White.webp" class="logo-top" alt="logo-kmi" />
                </div>
                <div class="k-indo">
                    VMS
                    <p>Vault Management System</p>
                </div>
            </div>
            <div class="wrap-login">
                <div class="title">Log in</div>
                <b-alert variant="danger" :show="statusLogin == 2023 || statusLogin == 2018 || statusLogin == 1003">Make sure the account are correct|</b-alert>
                <form @submit.prevent="login">
                    <div class="form-group">
                        <span><i class="fa fa-user"></i></span>
                        <input type="text" class="form-input" placeholder="username" v-model="form.username" />
                    </div>
                    <div class="form-group">
                        <span><i class="fa fa-lock"></i></span>
                        <input type="password" class="form-input" placeholder="password" v-model="form.password" />
                    </div>
                    <button type="submit" class="btn-login">
                        <span v-show="!isLoading">Login</span>
                        <Loader v-show="isLoading" />
                    </button>
                </form>
            </div>
        </div>

        <div class="footer">
            <div class="wrap-organizer">
                <div class="title-powered">Supervised by</div>
                <div class="wrap-img">
                    <img src="../assets/logo-kemendag.png" alt="" class="img-kemendag" />
                </div>
            </div>
            <div class="wrap-organizer">
                <div class="title-powered">Organized by</div>
                <div class="wrap-img">
                    <img src="../assets/logo_jfx.png" alt="" class="img-abx" />
                    <img src="../assets/logo-kbi-white.svg" alt="" class="img-abi" />
                    <img src="../assets/logo-kmi-white.png" alt="" class="img-abx" />
                    <img src="../assets/logo-pos.png" alt="" class="img-pos" />
                </div>
            </div>
            <div class="wrap-organizer">
                <div class="title-powered">The Technology by</div>
                <div class="wrap-img">
                    <img src="../assets/logo-bei-white.svg" alt="" class="img-abx" />
                </div>
            </div>
            <div class="wrap-organizer">
                <div class="title-powered">The Refinery is A Member of The LBMA</div>
                <div class="wrap-img">
                    <img src="../assets/lbma-white.svg" alt="" class="img-lbma" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from "axios";
import Loader from "../components/utility/Loader.vue";
import sha256 from "sha256";
export default {
    components: {
        Loader,
    },
    data() {
        return {
            form: {
                username: "",
                password: "",
            },
            isLoading: false,
            status: "",
            scriptCaptcha: "",
            webpSupported: true,
        };
    },
    methods: {
        transformImg(url) {
            if (this.webpSupported) {
                return url.replace(/\.\w{1,5}$/, ".webp");
            } else {
                return url;
            }
        },
        login() {
            this.isLoading = true;
            window.grecaptcha.enterprise.ready(async () => {
                const tokenCaptcha = await window.grecaptcha.enterprise.execute("6LcOUPckAAAAAHXPk2_ORUtBQK0u3aKSti-9UUSf", { action: "LOGINKLIRING" });
                let data = {
                    username: this.form.username,
                    password: sha256(this.form.password),
                    clientCaptchaKey: tokenCaptcha,
                };
                this.$store
                    .dispatch("LOGIN", data)
                    .then(() => {
                        // const role = sessionStorage.getItem("role");
                        // if ( role == 2 || role == 6 || role == 7) {
                            window.location.href = "/";
                        // } else if (role == 99) {
                        //     window.location.href = "management-user";
                        // } else if (role == 8 || role == 9) {
                        //     window.location.href = "/history-transaction";
                        // } else {
                        //     window.location.href = "/operator-deposite";
                        // }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            });
        },
    },
    computed: {
        statusLogin() {
            let status = this.$store.state.status_login;
            return status;
        },
        statusCOde() {
            let status = this.statusLogin.data.data.status_code;
            return status;
        },
    },
    async created() {
        if (!self.createImageBitmap) {
            this.webpSupported = false;
            return;
        }

        const webpData = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=";
        const blob = await fetch(webpData).then((r) => r.blob());
        this.webpSupported = await createImageBitmap(blob).then(
            () => true,
            () => false
        );
        this.scriptCaptcha = document.createElement("script");
        // this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6LdkqcUkAAAAAGwOMHZdqguhNkd2ktVfiD7DDRkV";
        this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6LcOUPckAAAAAHXPk2_ORUtBQK0u3aKSti-9UUSf";
        this.scriptCaptcha.async = true;

        document.body.appendChild(this.scriptCaptcha);
    },
    beforeDestroy() {
        document.body.removeChild(this.scriptCaptcha);
    },
};
</script>

<style scoped>
.wrap-content {
    background: radial-gradient(#1e1e2f, #1e1e24);
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0;
}

.content-login{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 35rem;
}

.wrap-login {
    background: #f8f9fe;
    width: 100%;
    border-radius: 5px;
    padding: 20px;
}

.logo-top {
    width: 4em;
    margin-bottom: -18px;
}

.brand {
    color: #fff;
    font-size: 60px;
    font-weight: bold;
    text-align: center;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    gap: 1.5rem;
}

.brand p {
    font-size: 13px;
    margin: -12px 0 25px;
}

.kmi {
    font-size: 25px;
    margin-top: -28px;
    color: #fff;
    font-family: sans-serif;
    margin-bottom: 26px;
    font-weight: bold;
}

.title {
    margin-bottom: 30px;
    font-size: 30px;
}

.form-group {
    position: relative;
    margin-bottom: 15px;
}

.form-group span {
    position: absolute;
    background: #ffffff;
    border: inherit;
    text-align: center;
    padding: 7px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    top: 1px;
    left: 1px;
    width: 2.8em;
    color: rgba(29, 37, 59, 0.5);
}

.form-input {
    width: 100%;
    border-radius: 5px;
    border: none;
    padding: 8px 3.6em;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-input:focus {
    border-color: var(--clr-primary);
    outline: 0;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.btn-login {
    width: 100%;
    background-color: #2c46d8;
    border: none;
    border-radius: 5px;
    padding: 11px;
    color: #ffffff;
    margin-top: 40px;
    margin-bottom: 10px;
    font-weight: bold;
    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

.btn-login:hover {
    box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
    transform: translateY(-1px);
}

.footer {
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    background-color: #27293D;
    width: 100%;
    padding: 1.25rem;
    gap: 2rem;
}

.wrap-organizer {
    text-align: center;
}

.title-powered {
    color: #9e9e9e;
    margin-bottom: 1rem;
}

.wrap-img {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
}

.img-kemendag{
    height: 3rem;
}

.img-abx {
    height: 2rem;
}

.img-pos {
    width: 3rem;
}

.img-lbma{
    width: 5rem;
}

.visitor {
    text-align: center;
    margin-top: 2rem;
    font-weight: 500;
    font-size: 14px;
}

@media only screen and (max-width: 600px) {
    .wrap-login {
        width: 87%;
    }
}
</style>
